import { Box, ColorOptions, ModBox, Spacer, Text } from '@jfs/ui-new'
import { TextInputNew } from '../../components/AdminInputs'
import { isEmpty } from '@jfs/utils'
import { useState } from 'react'
import { Switch } from 'react-native'

export const AutoSettle = ({ value, allValues, fieldName, setFieldValue, disabled, ...props }) => {
  const [toggle, setToggle] = useState(allValues?.autoSettle)
  const onToggle = (val) => {
    setToggle(val)
    if (val === true) {
      setFieldValue(fieldName, '0')
    } else {
      setFieldValue(fieldName, isEmpty(value) || value === '0' ? '1' : value)
    }
    setFieldValue('autoSettle', val)
  }

  const handleOnTextChange = (val) => {
    if (isEmpty(val) || Number(val) === 0) {
      setFieldValue(fieldName, '')
    } else {
      const regex = /^[0-9]*$/
      regex.test(val) && setFieldValue(fieldName, val)
    }
  }
  return (
    <>
      <Box flexDirection={'row'} align={'center'} ph={8}>
        <Box w={168}>
          <Text title={'Auto Settle'} {...textStyle} />
        </Box>
        <Spacer direction="horizontal" size={8} />
        <Switch
          value={toggle}
          onValueChange={onToggle}
          trackColor={{ false: '#1386B080', true: '#1386B080' }}
          disabled={disabled}
        />
      </Box>
      <Spacer direction="vertical" size={16} />
      <ModBox flexDirection={'row'} align={'center'} ph={8} justify={'space-between'} show={!toggle}>
        <Text title={'Auto Settle Days'} {...textStyle} />
        <Spacer direction="horizontal" size={8} />
        <TextInputNew
          value={value}
          onChangeText={handleOnTextChange}
          editable={!disabled}
          placeholder={'No. of Days'}
          maxLength={3}
          {...props}
          textWidth={150}
        />
      </ModBox>
    </>
  )
}

const textStyle = {
  fontFamily: 'jiotype-medium',
  fontSize: 12,
  color: 'PRIMARY_GREY' as ColorOptions,
}
